export default __webpack_public_path__ + "static/media/RioSantiago.df7b8fd8.kml";